import $ from 'jquery';
import Swiper, {Navigation, Pagination} from 'swiper';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');
Swiper.use([Navigation, Pagination]);


/**
 * Swiper
 */
$('.swiper-container').each(function () {

    // if (inBackend) return;

    const $element = $(this);

    const slidesPerView = $element.data('slides-per-view') || 1;


    var initialSlide = 0;
    var $slides = $element.find(".swiper-slide");

    $slides.each(function () {

        var categories = $(this).data("categories");
        var hash = window.location.hash.substring(1);

        if (!categories || !hash) {
            return;
        }

        if (categories.indexOf(hash) !== -1) {
            initialSlide = $slides.index($(this));
            return false;
        }
    });

    var autoplay = false;
    if ($(this).data("autoplay")) {
        autoplay = {
            delay: 6500
        };
    }



    new Swiper($element[0], {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        direction: 'horizontal',
        loop: true,
        initialSlide: initialSlide,
        autoHeight: true,
        speed: 400,
        spaceBetween: 2,
        keyboard: {
            enabled: true,
        },
        autoplay: autoplay,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});


